import axios from "axios";
import Alert from "components/misc/Alert";
import TableCol from "components/misc/TableCol";
import TableHeader from "components/misc/TableHeader";
import PriceValue from "components/partials/PriceValue";
import Api from "helpers/Api";
import moment from "moment";
import { useAppContext } from "providers/App";
import { useAuthDataContext } from "providers/Auth";
import { useEffect, useRef, useState } from "react";
import { Button, Col, Table } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Refs from "Refs";

function PackageCards(props) {

    const app = useAppContext();
    const auth = useAuthDataContext();
    const navigate = useNavigate();

    const tableRef = useRef(null);

    const { createMarkup, highlight } = props;

    const [state, setState] = useState({
        loading: true,
        refresh: false,
        setFilter: false,
        data: [

        ],
        filter: {

        },
        request: null,
    });

    useEffect(() => {
        if (props.refresh) {
            loadData();
        }
    }, [state.refresh, props.refresh, props.keyword]);

    useEffect(() => {
        if (state.loading) {
            props.onLoadStart();
        } else {
            props.onLoadEnd();
        }
    }, [state.loading]);

    useEffect(() => {
        props.onResult(state.data.length);
    }, [state.data]);

    const loadData = () => {
        if (state.request) {
            state.request.cancel();
        }

        let request = axios.CancelToken.source();

        setState(prev => ({
            ...prev,
            request: request,
            loading: true,
        }));

        let url = 'search/package-cards';

        Api.get(url, {
            params: {
                keyword: props.keyword
            },
            cancelToken: request.token
        }).then(res => {
            setState(prev => ({
                ...prev,
                data: res.data.items,
                loading: false,
                sorting: false,
                filter: {
                    ...prev.filter,
                    ...res.data.filter,
                }
            }));
        });
    }

    const show = id => {
        let modal = Refs.getInstance().getRef('packageCard');

        modal.edit(id);
    }

    const all = () => {
        navigate('/cards?search=' + props.keyword);
    }

    if (state.data.length === 0) {
        return null;
    }

    return (
        <Col xl={6} lg={6}>
            <div className="card">
                <div className="d-flex card-header justify-content-between align-items-start">
                    <h4 className="header-title">Пакетни карти</h4>

                    <Button
                        variant="dark"
                        size="sm"
                        onClick={all}
                    >
                        Всички карти
                    </Button>
                </div>
                <div className="card-body with-table pt-0">
                    {state.data.length === 0
                        ?
                        <Alert>
                            Няма намерена информация
                        </Alert>
                        :
                        <Table className="" responsive striped hover ref={tableRef}>
                            <TableHeader
                                tableRef={tableRef}
                            >
                                <TableCol>ID</TableCol>
                                <TableCol>Тип</TableCol>
                                <TableCol>Номер</TableCol>
                                <TableCol>Клиент</TableCol>
                                <TableCol className="text-right">Отстъпка</TableCol>
                            </TableHeader>
                            <tbody>
                                {state.data.map(c =>
                                    <tr
                                        key={'c-' + c.id}
                                        className={c.deleted ? 'deleted' : ''}
                                    >
                                        <td>
                                            <span className="link" onClick={e => show(c.id)} dangerouslySetInnerHTML={createMarkup(highlight(c.id))} />
                                        </td>
                                        <td>
                                            <span>{c.card?.name}</span>
                                        </td>
                                        <td>
                                            <span dangerouslySetInnerHTML={createMarkup(highlight(c.num))} />
                                        </td>
                                        <td>
                                            <span dangerouslySetInnerHTML={createMarkup(highlight(c.client?.name))} />
                                        </td>
                                        <td className="text-right">
                                            <span>
                                                {c.discount ? c.discount + ' %' : '0 %'}
                                            </span>
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </Table>
                    }
                </div>
            </div>
        </Col>
    )
}

export default PackageCards;